import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { postJson } from '#/utils/http/postJson';

import type { ApiShortUrlType } from './types/ApiShortUrlType';

type Args = {
  toType: ApiShortUrlType;
  toId?: string;
  toUrl?: string;
  extraParams?: {
    name: string;
    value: string;
  }[];
  locale: I18nLocale;
};

export async function apiGetShortUrl({
  toType,
  toId,
  toUrl,
  extraParams = [],
  locale,
}: Args): Promise<string> {
  return postJson<{ url: string }>('/data/short-urls', {
    toType,
    toId,
    toUrl,
    extraParams,
    locale,
  }).then(({ url }) => url);
}
